import * as React from "react";

const Card = ({ width = "20", height = "15", fill = "#6B47F5", vw = "20", vh = "15" }) => (
  <svg width="31" height="30" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.25"
      d="M1.8335 6C1.8335 4.34315 3.17664 3 4.8335 3H13.8335C15.4904 3 16.8335 4.34315 16.8335 6V12C16.8335 13.6569 15.4904 15 13.8335 15H4.8335C3.17664 15 1.8335 13.6569 1.8335 12V6Z"
      fill="url(#paint0_linear_5417_64003)"
    />
    <path
      d="M7.8335 7.5C7.8335 6.67157 7.16192 6 6.3335 6C5.50507 6 4.8335 6.67157 4.8335 7.5C4.8335 8.32843 5.50507 9 6.3335 9C5.37205 9 4.53262 9.6033 4.0835 10.5C4.0835 10.9142 4.41928 11.25 4.8335 11.25H7.8335C8.24771 11.25 8.5835 10.9142 8.5835 10.5C8.13438 9.6033 7.29494 9 6.3335 9C7.16192 9 7.8335 8.32843 7.8335 7.5Z"
      fill="url(#paint1_linear_5417_64003)"
    />
    <path
      d="M9.3335 7.3125C9.3335 7.00184 9.58534 6.75 9.896 6.75H13.646C13.9567 6.75 14.2085 7.00184 14.2085 7.3125C14.2085 7.62316 13.9567 7.875 13.646 7.875H9.896C9.58534 7.875 9.3335 7.62316 9.3335 7.3125Z"
      fill="url(#paint2_linear_5417_64003)"
    />
    <path
      d="M9.3335 9.375C9.3335 9.06434 9.58534 8.8125 9.896 8.8125H11.396C11.7067 8.8125 11.9585 9.06434 11.9585 9.375C11.9585 9.68566 11.7067 9.9375 11.396 9.9375H9.896C9.58534 9.9375 9.3335 9.68566 9.3335 9.375Z"
      fill="url(#paint3_linear_5417_64003)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5417_64003"
        x1="5.5258"
        y1="14.0129"
        x2="27.3892"
        y2="-16.2568"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6B47F5" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5417_64003"
        x1="6.5758"
        y1="10.8181"
        x2="14.314"
        y2="-5.7111"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6B47F5" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5417_64003"
        x1="6.5758"
        y1="10.8181"
        x2="14.314"
        y2="-5.7111"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6B47F5" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5417_64003"
        x1="6.5758"
        y1="10.8181"
        x2="14.314"
        y2="-5.7111"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6B47F5" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default Card;
